<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <table
            v-if="arrayModel.length > 0"
            class="table table-bordered table-striped table-sm"
        >
            <thead>
                <tr>
                    <th>Opciones</th>
                    <th>Resumen</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="model in arrayModel" :key="model.id">
                    <td>
                        <button
                            type="button"
                            @click="changeView(model.id)"
                            class="btn btn-warning btn-sm"
                        >
                            <em class="fa fa-pencil"></em>
                        </button>
                        <button
                            @click="deleteModel(model.id)"
                            type="button"
                            class="btn btn-danger btn-sm"
                        >
                            <em class="fa fa-trash"></em>
                        </button>
                    </td>
                    <td v-html="model.summary"></td>
                </tr>
            </tbody>
        </table>
        <nav>
            <ul class="pagination">
                <li class="page-item" v-if="pagination.current_page > 1">
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page - 1)"
                        >Ant</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="page in pagesNumber"
                    :key="page"
                    :class="[page == isActived ? 'active' : '']"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(page)"
                        v-text="page"
                    ></a>
                </li>
                <li
                    class="page-item"
                    v-if="pagination.current_page < pagination.last_page"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page + 1)"
                        >Sig</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            arrayModel: [],
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getListModel(page);
        },
        getListModel(page = 1) {
            let me = this;
            axios
                .get("/api/contests/requirements?contest_id=" + me.model_id + "?page=" + page)
                .then(function (response) {
                    me.arrayModel = response.data.models.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
        changeView(id) {
            this.$emit("change", id);
        },
        deleteModel(id) {
            let me = this;
            this.$swal({
                title: "Esta seguro?",
                text: "No podra revertir este cambio!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Si, borrarlo!",
            }).then((result) => {
                if (result.value) {
                    axios
                        .delete("/api/contests/requirements/" + id)
                        .then(function (response) {
                            me.getListModel();
                            me.showActionSuccess("Borrado exitoso!");
                        })
                        .catch(function (error) {});
                }
            });
        },
        showActionSuccess($message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: $message,
            });
        },
    },
    mounted() {
        this.getListModel();
    },
};
</script>
